import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';
import { toast } from 'sonner';
import { useAuth } from '../contexts/AuthContext';

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const { refreshUser } = useAuth();
  const [status, setStatus] = useState('Authenticating...');

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.replace('#', '?'));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        toast.error("No session ID found");
        navigate('/login');
        return;
      }

      try {
        setStatus('Exchanging session...');
        const resp = await api.post('/auth/exchange', { session_id: sessionId });
        
        setStatus('Loading profile...');
        await refreshUser();
        
        toast.success(`Welcome, ${resp.data?.user?.name || 'User'}!`);
        navigate('/chat');
      } catch (err) {
        const statusCode = err?.response?.status;
        const detail = err?.response?.data?.detail;
        
        console.error("Auth exchange failed:", { statusCode, detail, err });
        
        if (statusCode === 401) {
          toast.error("Session expired. Please sign in again.");
        } else if (statusCode === 403) {
          toast.error(detail || "Your account is blocked. Contact admin.");
        } else {
          toast.error("Authentication failed. Please try again.");
        }
        navigate('/login');
      }
    };

    processAuth();
  }, [navigate, refreshUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[rgb(var(--bg-0))]">
      <div className="flex flex-col items-center gap-4">
         <div className="h-8 w-8 border-4 border-cyan-500 border-t-transparent rounded-full animate-spin"></div>
         <p className="text-white/50" data-testid="auth-callback-status">{status}</p>
      </div>
    </div>
  );
};

export default AuthCallback;
